import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthScreen } from '../components/AuthScreen';
import { useSession } from '../context/SessionContext';
import { UserRole } from '../types';

export const WorkerLogin: React.FC = () => {
    const navigate = useNavigate();
    const { handleAuthSuccess, setRole } = useSession();

    const handleSuccess = async (identifier: string, roleArg: string, name?: string) => {
        const success = await handleAuthSuccess(identifier, UserRole.WORKER, name);
        if (success) {
            navigate('/worker');
        } else {
            throw new Error("Login failed. Please check your credentials and try again.");
        }
    };

    const handleBack = () => {
        setRole(UserRole.NONE);
        navigate('/');
    };

    return (
        <AuthScreen
            onSuccess={handleSuccess}
            roleText={UserRole.WORKER}
            onBack={handleBack}
        />
    );
};
